// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + "8d6ebfdc02fc9508d925" + ".js";
};